export const getPlatform = () => {
    const platform = window.navigator.platform.toLowerCase();
    const isWindows = platform.indexOf('win') !== -1;
    const isMac = platform.indexOf('mac') !== -1;

    return isWindows ? 'win' : isMac ? 'mac' : null;
};

export const PlayerLanguages = {
    bg: 'en',
    cz: 'en',
    de: 'de',
    fr: 'fr',
    gr: 'en',
    hr: 'en',
    it: 'it',
    lt: 'en',
    pt: 'pt',
    ro: 'en',
    sp: 'es',
    tr: 'tr',
    us: 'en',
};